module.exports = __webpack_public_path__ + "static/img/bg-introVideo@3x.e9de25d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/bg-introVideo@3x.png
// module id = 6+4j
// module chunks = 18